export type EventHandler<T> = (args: T) => void;
export class DelegateEvent<T = void> {
    private listeners?: Set<EventHandler<T>>;
    subscribe(handler: EventHandler<T>) {
        if (!this.listeners) { this.listeners = new Set(); }
        this.listeners.add(handler);
    }

    unsubscribe(handler: EventHandler<T>) {
        this.listeners?.delete(handler);
    }

    invoke(data: T) {
        if (!this.listeners) return;
        for (const listener of this.listeners) {
            listener(data);
        }
    }

    clear() {
        if (this.listeners) {
            this.listeners.clear();
        }
    }

    get hasListeners(): boolean {
        return !!this.listeners && this.listeners.size > 0;
    }
    
}